const DEFAULT_GEOLOCATION_TIMEOUT_MS = 12000;

const mapGeolocationError = (error) => {
    if (!error) return 'unknown';
    if (error.code === 1) return 'permissionDenied';
    if (error.code === 2) return 'positionUnavailable';
    if (error.code === 3) return 'timeout';
    return 'unknown';
};

export const requestStartLocation = (timeoutMs = DEFAULT_GEOLOCATION_TIMEOUT_MS) => new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
        resolve({ locationUnavailableReason: 'unsupported' });
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const coords = position?.coords || {};
            if (
                !Number.isFinite(coords.latitude) ||
                !Number.isFinite(coords.longitude) ||
                !Number.isFinite(coords.accuracy) ||
                coords.accuracy <= 0
            ) {
                resolve({ locationUnavailableReason: 'unknown' });
                return;
            }
            resolve({
                location: {
                    latitude: coords.latitude,
                    longitude: coords.longitude,
                    accuracyMeters: coords.accuracy
                }
            });
        },
        (error) => {
            resolve({ locationUnavailableReason: mapGeolocationError(error) });
        },
        {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: timeoutMs
        }
    );
});

export const didCaptureLocation = (payload = {}) => Boolean(payload.location);
